"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideFocusRing = exports.focusRingStyle = exports.doubleFocusRing = exports.default = void 0;
var _excluded = ["extension", "hideOriginalOutline", "hideOriginalShadow"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var focusRing = function focusRing(theme) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var extension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return {
    ':focus-visible': _defineProperty({
      outline: 'none'
    }, extension, {
      outlineStyle: 'solid',
      outlineWidth: "".concat(size, "px"),
      outlineOffset: "".concat(offset, "px"),
      outlineColor: theme.color.focus.default
    })
  };
};
var focusRingStyle = exports.focusRingStyle = function focusRingStyle(_ref) {
  var theme = _ref.theme,
    _ref$outlineSize = _ref.outlineSize,
    outlineSize = _ref$outlineSize === void 0 ? 2 : _ref$outlineSize,
    _ref$outlineOffset = _ref.outlineOffset,
    outlineOffset = _ref$outlineOffset === void 0 ? 2 : _ref$outlineOffset,
    _ref$shadowSize = _ref.shadowSize,
    shadowSize = _ref$shadowSize === void 0 ? 0 : _ref$shadowSize,
    _ref$shadowInset = _ref.shadowInset,
    shadowInset = _ref$shadowInset === void 0 ? false : _ref$shadowInset;
  return {
    boxShadow: "0px 0px 0px  ".concat(shadowSize, "px ").concat(theme.color.focus.inverse, " ").concat(shadowInset ? 'inset' : ''),
    outlineStyle: 'solid',
    outlineWidth: "".concat(outlineSize, "px"),
    outlineOffset: "".concat(outlineOffset, "px"),
    outlineColor: theme.color.focus.default
  };
};
var doubleFocusRing = exports.doubleFocusRing = function doubleFocusRing(_ref2) {
  var _ref2$extension = _ref2.extension,
    extension = _ref2$extension === void 0 ? '' : _ref2$extension,
    _ref2$hideOriginalOut = _ref2.hideOriginalOutline,
    hideOriginalOutline = _ref2$hideOriginalOut === void 0 ? false : _ref2$hideOriginalOut,
    _ref2$hideOriginalSha = _ref2.hideOriginalShadow,
    hideOriginalShadow = _ref2$hideOriginalSha === void 0 ? false : _ref2$hideOriginalSha,
    props = _objectWithoutProperties(_ref2, _excluded);
  return {
    ':focus-visible': _objectSpread(_objectSpread(_objectSpread({}, hideOriginalOutline && {
      outline: 'none'
    }), hideOriginalShadow && {
      boxShadow: 'none'
    }), {}, _defineProperty({}, extension, _objectSpread({}, focusRingStyle(props))))
  };
};
var _default = exports.default = focusRing;
var hideFocusRing = exports.hideFocusRing = function hideFocusRing() {
  return {
    ':focus-visible': {
      outline: 'none'
    }
  };
};